export default {
  characters: [
    {
      id: 0,
      name: "Jon Snow",
      image: "/images/jon.jpg",
    },
    {
      id: 1,
      name: "Daenerys Targaryen",
      image: "/images/daenerys.jpg",
    },
    {
      id: 2,
      name: "Sansa Stark",
      image: "/images/sansa.jpg",
    },
    {
      id: 3,
      name: "Arya Stark",
      image: "/images/arya.jpg",
    },
    {
      id: 4,
      name: "Tyrion Lannister",
      image: "/images/tyrion.jpg",
    },
    {
      id: 5,
      name: "Jamie Lannister",
      image: "/images/jamie.jpg",
    },
    {
      id: 6,
      name: "Cersei Lannister",
      image: "/images/cersei.jpg",
    },
    {
      id: 7,
      name: "Samwell Tarly",
      image: "/images/samwell.jpg",
    },
    {
      id: 8,
      name: "Brienne of Tarth",
      image: "/images/brienne.jpg",
    },
    {
      id: 9,
      name: "Jorah Mormont",
      image: "/images/jorah.jpg",
    },
    {
      id: 10,
      name: "Davos Seaworth",
      image: "/images/davos.jpg",
    },
    {
      id: 11,
      name: "Petyr Baelish",
      image: "/images/peter.jpg",
    },
  ]
}